import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Image, rem, Text, VStack } from '@bonusly/design-system';

import emptyNotification from '../../assets/images/empty-notification.png';

export const NotificationEmptyState: FC = () => {
	const { t } = useTranslation('navigation');

	return (
		<Box data-testid="notification-empty-state" h={rem(304)} px={rem(20)} py={rem(40)}>
			<VStack h={rem(224)} w={rem(394)} gap={rem(8)}>
				<Image h={rem(140)} objectFit="contain" src={emptyNotification} alt={t('notification.empty_state_image')} />
				<Text lineHeight={rem(28)} fontFamily="ui" fontWeight="medium" fontSize={150}>
					{t('notification.no_notifications_title')}
				</Text>
				<VStack p={0} gap={0}>
					<Text size="sm" fontFamily="ui" fontSize={50} textColor="text.softer">
						{t('notification.no_notifications_detail_line1')}
					</Text>
					<Text size="sm" fontFamily="ui" fontSize={50} textColor="text.softer">
						{t('notification.no_notifications_detail_line2')}
					</Text>
				</VStack>
			</VStack>
		</Box>
	);
};
